import React from "react";
import "./Store_Product_Card.css";
import { useNavigate } from "react-router-dom";
import { encodeId } from "../../../../utils/common";

const Store_Product_Card = ({ product }) => {
  const navigate = useNavigate();

  return (
    <section
      className="Store_Product_Card"
      onClick={() => {
        navigate(`/product-description/${encodeId(product?.id)}`);
      }}
    >
      <div className="right_side_box"></div>

      <div className="img_holder">
        <img
          src={process.env.REACT_APP_IMG_URL + product?.image}
          className="prod_img"
        />
      </div>

      <div className="text_div">
        <div className="white_curved_div">
          <p className="prod_title">{product?.name}</p>
        </div>

        {product?.Offered_Product?.id && (
          <div className="discount_div">
            <p className="discount_text">
              {product?.Offered_Product?.Discount_Type?.id === 1
                ? product?.Offered_Product?.discount
                : `${product?.Offered_Product?.discount}%`}{" "}
              Off
            </p>
          </div>
        )}
      </div>
    </section>
  );
};

export default Store_Product_Card;
